import { useFormik } from "formik";
import { useState, useEffect } from "react";
import * as yup from 'yup';
import axiosInstance from "../../../../Services/axiosCommon";
import { TextMediumXL } from "../../../../Components/Text/MediumText";
import { NuInput } from "../../../../Components/Utils/Input";
import { CancelButton, NextButton, Submit } from "../../../../Components/Utils/Buttons";
import { useToast } from "../../../../Components/Others/ToastServices";
import ModalContainer from "../../../../Components/Others/ModalContainer";

const SendOTP = ({ surveyReportViewId, onClose,fetchTasks }) => {
    const [nextStep, setNextStep] = useState(false);
    const toast = useToast();
    const [timer, setTimer] = useState(180);
    const [resendEnabled, setResendEnabled] = useState(false);
  
   
    const formik = useFormik({
      initialValues: { email: "", OTP: "" },
      validateOnChange: false,
     validationSchema: yup.object({
        email: yup.string().required("Email is required"),
        OTP: nextStep 
          ? yup.string().required("OTP is required") 
          : yup.string(),
          
              }),
      onSubmit: () => {},
    });
  
    useEffect(() => {
      if (surveyReportViewId) {
        fetchClientEmail();
      }
    }, [surveyReportViewId]);
  
    const fetchClientEmail = async () => {
      try {
        const res = await axiosInstance.get(`/survey-report/client-email/${surveyReportViewId}`);
        formik.setFieldValue("email", res.data.data);
      } catch (err) {
        toast.open({
          type: "error",
          message: "Failed to fetch email",
          description: err.message,
        });
      }
    };
  
    const handleSendOTP = () => {
      axiosInstance.post(`/survey-report/generate-otp/${surveyReportViewId}`, {
        email: formik.values.email,
      })
        .then((res) => {
          if (res.data.status) {
            toast.open({
              type: "success",
              message: "OTP Sent",
            });
            setNextStep(true);
            setTimer(180);
            setResendEnabled(false);
          } else {
            toast.open({
              type: "error",
              message: "Failed to send OTP",
              description: res.data.msg,
            });
          }
        })
        .catch((err) => {
          toast.open({
            type: "error",
            message: "Network Error",
            description: err.message,
          });
        });
    };
  
    const handleVerifyOTP = () => {
      axiosInstance.put(`/survey-report/verify-otp/${surveyReportViewId}`, {
        OTP: String(formik.values.OTP)
      })
        .then((res) => {
          if (res.data.status) {
            toast.open({
              type: "success",
              message: "OTP Verified",
            });
            fetchTasks(surveyReportViewId)

            onClose();
          } else {
            toast.open({
              type: "error",
              message: "Invalid OTP",
              description: res.data.msg,
            });
          }
        })
        .catch((err) => {
          toast.open({
            type: "error",
            message: "Network Error",
            description: err.message,
          });
        });
    };
  
    const handleResendOTP = () => {
      setTimer(180);
      setResendEnabled(false);
      handleSendOTP();
    };
  
    useEffect(() => {
      let interval = null;
      if (timer > 0) {
        interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      } else {
        setResendEnabled(true);
        clearInterval(interval);
      }
      return () => clearInterval(interval);
    }, [timer]);
  
    const formatTime = (seconds) => {
      const min = Math.floor(seconds / 60);
      const sec = seconds % 60;
      return `${min}:${sec < 10 ? "0" : ""}${sec}`;
    };
  
    return (
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
        <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
          <form onSubmit={formik.handleSubmit}>
            {!nextStep ? (
              <div>
                <TextMediumXL content="Email" otherStyles="mb-4" align="center" />
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="example@email.com"
                  formik={formik}
                  name="email"
                  width="w-full"
                 
                />
                <div className="flex justify-end mt-6 gap-3">
                  <CancelButton handleClick={onClose} />
                  <NextButton name="Send OTP" handleClick={handleSendOTP} />
                </div>
              </div>
            ) : (
              <div>
                <TextMediumXL content="Verify OTP" otherStyles="mb-4" align="center" />
                <div className="flex items-end gap-2">
                  <div className="flex-1">
                    <NuInput
                      type="number"
                      label="OTP"
                      placeholder="Enter OTP"
                      formik={formik}
                      name="OTP"
                      width="w-full"
                    />
                  </div>
                  <div className="flex flex-col justify-center items-center w-20 h-10 mb-2 border rounded-lg text-sm text-gray-700 p-2">
                    <span className="font-semibold">{formatTime(timer)}</span>
                  </div>
                </div>
  
                <div className="flex justify-end mt-6 gap-3">
                  <CancelButton handleClick={onClose} />
                  <Submit handleClick={handleVerifyOTP} />
                  <button
                    type="button"
                    onClick={handleResendOTP}
                    disabled={!resendEnabled}
                    className={`px-3 py-1 rounded-md border ${
                      resendEnabled ? "text-baseColor-primary border-baseColor-primary" : "text-gray-400 border-gray-300 cursor-not-allowed"
                    }`}
                  >
                    Resend
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  };
  
  export default SendOTP;




  
 
  
 
  
